import React from "react";
import styles from "./Loader.module.scss";

export default function Loader() {
  const text = "ticketgo";

  return (
    <div className={styles.container}>
      <div className={styles.loader} aria-label={text}>
        {text.split("").map((letter, index) => (
          <span key={`${letter}-${index}`} style={{ "--i": index }}>
            {letter}
          </span>
        ))}
      </div>
    </div>
  );
}